<script>
    import { createEventDispatcher } from 'svelte';

    export let validPassword = {
        dirty: false,
        valid: true,
        errors: []
    };
    export let isResetPassword = false;
    export let confirmPassword = false;

    const dispatch = createEventDispatcher();

    let externalUser = {
        password: '',
        display_password: false,
        confirm_password: '',
        display_confirm_password: false
    }
    let validationLoaded = false; // for some reason verify password function is being called on load

    function verifyPassword(password, passwordType) {
        // Fix problem, this function is called once on load
        if (!validationLoaded) {
            validationLoaded = true;
            return;
        }

        validPassword = {
            dirty: true,
            valid: false,
            errors: []
        }

        // Verify if needs password confirmation
        if (confirmPassword) {
            externalUser[passwordType] = password;
            if (externalUser.password !== externalUser.confirm_password) {
                validPassword.valid = false;
                validPassword.errors.push('Password and confirm password does not match');
                return;
            }
        }

        if (password.length < 8 || password.length > 20) validPassword.errors.push('Password length must be of 8-20 characters');

        // At least one uppercase, one lowercase and one number
        const hasUppercase = /[A-Z]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasNumber = /\d/.test(password);
        if (!hasUppercase || !hasLowercase) validPassword.errors.push('Password must include upper and lowercase letters');
        if (!hasNumber) validPassword.errors.push('Password must include at least one number');
        if (validPassword.errors.length === 0) validPassword.valid = true;
    }

    function valueChanged(value) {
        dispatch('change', { value: value });
    }
</script>

<div class="form-group">
    <label for="external-email">*{isResetPassword ? 'New ' : ''}Password</label>
    <div class="input-group">
        <input required on:keyup={(e) => verifyPassword(e.target.value, 'password')} on:change={(e) => valueChanged(e.target.value)} 
            value={externalUser.password}
            type="{externalUser.display_password ? 'text' : 'password'}" class="form-control" name="external-password" id="external-password" placeholder="••••••••">
        <div class="input-group-prepend pointer" on:click={() => externalUser.display_password = !externalUser.display_password}>
            <span class="input-group-text">
                <i class="fa fa-eye{externalUser.display_password ? '-slash' : ''}"></i>
            </span>
        </div>
    </div>
</div>

{#if confirmPassword}
    <div class="form-group">
        <label for="external-email">*Confirm {isResetPassword ? 'New ' : ''}Password</label>
        <div class="input-group">
            <input required on:keyup={(e) => verifyPassword(e.target.value, 'confirm_password')} 
                value={externalUser.confirm_password}
                type="{externalUser.display_confirm_password ? 'text' : 'password'}" class="form-control" name="external-password" id="external-password" placeholder="••••••••">
            <div class="input-group-prepend pointer" on:click={() => externalUser.display_confirm_password = !externalUser.display_confirm_password}>
                <span class="input-group-text">
                    <i class="fa fa-eye{externalUser.display_confirm_password ? '-slash' : ''}"></i>
                </span>
            </div>
        </div>
    </div>
{/if}

<div class="form-group">
    {#if !validPassword.valid && validPassword.dirty}
        {#each validPassword.errors as error}
            <small class="text-danger d-block">{error}</small>
        {/each}
    {/if}
</div>